export const UserModule={
    namespaced:true,

    state:{
        user:{
            name:"",
            dp:"",
            persona:"",
            links:"",
            username:""
        },
        userapp:{
            note:"",
            noteLoaded:false
        }
    },

    mutations:{
        SET_USER(state, user){
            state.user=user;
        },
        SET_APP(state,app){
            state.userapp=app;
        }
    },

    actions:{
        setUser({commit}, user){
            commit('SET_USER',user);
        },
        setUserApp({commit}, app){
            commit('SET_APP',app);
        },
    },
};